/* import __COLOCATED_TEMPLATE__ from './external-bank-accounts.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();